import React, { Component } from 'react';
import cx from 'classnames';
import * as PropTypes from 'prop-types';
import { Dropdown, Menu } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import styles from './widget.module.sass';
import { WIDGET_CODES } from '../../../../redux/constants/widgets';
import { WidgetShape } from '../../../../shapes';
import MostWidespreadTag from '../../../../widgets/MostWidespreadTag';
import TopTrendingTags from '../../../../widgets/TopTrendingTags';
import FalsePositiveAverage from '../../../../widgets/FalsePositiveAverage';

export class Widget extends Component {
  handleWidgetUpdate = (newWidget) => {
    this.props.onUpdate(newWidget);
  };

  renderSelect = (toggle, withDeleteOption = false) => {
    const { availableWidgets, size } = this.props;
    const menu = (
      <Menu>
        {availableWidgets
          .filter(
            (w) =>
              // no duplicates
              // !dashboard.widgets.find((dw) => dw.type === w.type) &&
              // widget is compatible with the cell size
              w.size === size,
          )
          .map((w) => (
            <Menu.Item key={w.uuid} onClick={() => this.handleWidgetUpdate(w)}>
              {w.title}
            </Menu.Item>
          ))}
        {withDeleteOption && <Menu.Divider />}
        {withDeleteOption && (
          <Menu.Item onClick={() => this.handleWidgetUpdate(null)}>
            Delete Widget
          </Menu.Item>
        )}
      </Menu>
    );

    return (
      <div className={styles.empty}>
        <Dropdown overlay={menu} trigger={['click']}>
          {toggle}
        </Dropdown>
      </div>
    );
  };

  renderWidgetBody = () => {
    const { widget } = this.props;
    switch (widget.widget_type) {
      case WIDGET_CODES.MOST_WIDESPREAD_TAG:
        return <MostWidespreadTag />;
      case WIDGET_CODES.TOP_TRENDING_TAGS:
        return <TopTrendingTags />;
      case WIDGET_CODES.FP_AVG:
        return <FalsePositiveAverage />;
      default:
        return null;
    }
  };

  render() {
    const { widget, size } = this.props;
    const widgetName = {
      [WIDGET_CODES.MOST_WIDESPREAD_TAG]: 'Most Widespread Tag',
      [WIDGET_CODES.TOP_TRENDING_TAGS]: 'Top Trending Tags - 7 Days',
      [WIDGET_CODES.FP_AVG]: 'False Positive Average Total Score',
    }[widget?.widget_type];

    return (
      <div
        className={cx(
          styles.widget,
          styles[`widget__size-${size.toLowerCase()}`],
        )}
      >
        {widget ? (
          <div className={styles.body}>
            <div className={styles.header}>
              <div className={styles.text}>{widgetName}</div>
              <div className={styles.edit_button}>
                {this.renderSelect(<EditOutlined />, true)}
              </div>
            </div>
            {this.renderWidgetBody()}
          </div>
        ) : (
          this.renderSelect(
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              className="ant-dropdown-link"
              href=""
              onClick={(e) => e.preventDefault()}
            >
              + Add New Widget
            </a>,
          )
        )}
      </div>
    );
  }
}

Widget.propTypes = {
  widget: WidgetShape.isRequired,
  availableWidgets: PropTypes.arrayOf(WidgetShape).isRequired,
  onUpdate: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
};
export default Widget;
